import { FC } from 'react'
import { GridDensity } from '@mui/x-data-grid-premium'
import { Box, Stack, Typography } from '@mui/material'
import DensityLargeIcon from '@mui/icons-material/DensityLarge'
import DensityMediumIcon from '@mui/icons-material/DensityMedium'
import DensitySmallIcon from '@mui/icons-material/DensitySmall'
import './DataGridContext.css'

interface DensityMenuProps {
  changeDensity: (_newDensity: GridDensity) => void
}

const DensityMenu: FC<DensityMenuProps> = ({ changeDensity }) => {
  return (
    <Stack sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <Box className="density-menu-item" onClick={() => changeDensity('compact')}>
        <DensitySmallIcon sx={{ height: 30, width: 30 }} />
        <Typography sx={{ fontSize: 14 }}>Compact</Typography>
      </Box>
      <Box className="density-menu-item" onClick={() => changeDensity('standard')}>
        <DensityMediumIcon sx={{ height: 30, width: 30 }} />
        <Typography sx={{ fontSize: 14 }}>Standard</Typography>
      </Box>
      <Box className="density-menu-item" onClick={() => changeDensity('comfortable')}>
        <DensityLargeIcon sx={{ height: 30, width: 30 }} />
        <Typography sx={{ fontSize: 14 }}>Comfortable</Typography>
      </Box>
    </Stack>
  )
}
export default DensityMenu
